import XLSX from 'xlsx';
import { findIndex, isEmpty } from 'lodash';

import { LAYER_SUBTYPES } from '../api/Layers/Layers';

import methodPromise from './method-promise-wrapper';
import { urlRegex } from './regex-utils';

/**
 * Fetch the Excel stored in the URL.
 *
 * @async
 * @param {object} arg - The argument object.
 * @param {string} arg.url - The URL where the Excel is stored.
 * @param {string} arg.layerSubType - The layer subtype.
 * @returns {string[]} The list of sheets.
 * @throws {Error} If something goes wrong.
 */

const loadExcelSheets = async ({ url, layerSubType }) => {
  try {
    if (isEmpty(url)) throw new Error('The url is empty');
    if (!url.match(urlRegex)) throw new Error('No identifiable url');

    let sheetList = [];

    if (layerSubType === LAYER_SUBTYPES.EXCEL) {
      const response = await fetch(url);
      if (response.ok) {
        const buffer = await response.arrayBuffer();
        const data = new Uint8Array(buffer);
        const workbook = XLSX.read(data, { type: 'array' });
        sheetList = workbook.SheetNames;
      }
    }

    if (layerSubType === LAYER_SUBTYPES.GOOGLE_SHEETS) {
      const urlArray = url.split('/');
      const idIndex = findIndex(urlArray, path => path === 'd') + 1;
      sheetList = await methodPromise('layers.loadGoogleSheets', {
        spreadsheetId: urlArray[idIndex]
      });
    }

    return sheetList;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default loadExcelSheets;
